
import mongoose from 'mongoose'
import FileSchema from './schemas/FileSchema'

const FileModel = mongoose.model("file", FileSchema, "file")

export default FileModel